import React from 'react'
import { NormalizedDocumentTemplateViewItem } from './model'

export interface DragDropAreaContextValue {
    articles: NormalizedDocumentTemplateViewItem[]
    draggingId?: string
    handleDraggingId?: (id: string) => void
    tabData: NormalizedDocumentTemplateViewItem
    isRegroup: boolean
    handleRegroup?: (state: boolean) => void
    setAutoCollapsedId: (id?: string) => void
    typeForFullView?: 'GENERAL' | 'PRODUCTS' | 'EXECUTION'
}

export const DragDropAreaContext = React.createContext(
    {} as DragDropAreaContextValue
)

export interface DragDropAreaProviderProps {
    articles: NormalizedDocumentTemplateViewItem[]
    tabData: NormalizedDocumentTemplateViewItem
    setAutoCollapsedId: (id?: string) => void
    typeForFullView?: 'GENERAL' | 'PRODUCTS' | 'EXECUTION'
}

export const DragDropAreaProvider: React.FC<DragDropAreaProviderProps> = React.memo(
    ({ articles, children, tabData, setAutoCollapsedId, typeForFullView }) => {
        const [isRegroup, setIsRegroup] = React.useState<boolean>(false)
        const [draggingId, setDraggingId] = React.useState<string | undefined>()
        const handleDraggingId = React.useCallback(
            (id: string) => {
                setDraggingId(id)
            },
            [setDraggingId]
        )
        const handleRegroup = React.useCallback(
            (value: boolean) => {
                setIsRegroup(value)
            },
            [setIsRegroup]
        )
        return (
            <DragDropAreaContext.Provider
                value={{
                    articles,
                    draggingId,
                    handleDraggingId,
                    tabData,
                    isRegroup,
                    handleRegroup,
                    setAutoCollapsedId,
                    typeForFullView,
                }}
            >
                {children}
            </DragDropAreaContext.Provider>
        )
    }
)
